// export default defineNuxtPlugin({
//   name: "vue-i18n-cookie",
//   dependsOn: ["i18n:plugin"],
//   async setup(nuxtApp) {
//     const i18n: any = nuxtApp.vueApp.$nuxt.$i18n;
//     const cookie = i18n.getLocaleCookie();
//     const route = useRoute();
//    const localeCookie = useCookie("locale");
//     watch(
//       [() => i18n.locale.value, () => route.path],
//       () => {
//         const path = route.path;
//         // localeCookie.value = i18n.locale.value;
//         const hasLocalePrefix =
//           /^\/(en|fr|es|de|ar|ru|tr|az|zh|it|he|fa|pt|uz)(\/|$)/.test(path);

//         if (!hasLocalePrefix) {
//           // URL بدون زبان → برگرد به default
//           i18n.setLocale(i18n.defaultLocale);
//           i18n.setLocaleCookie(i18n.defaultLocale);
//         } else {
//           // URL زبان دارد → همان را در کوکی ذخیره کن
//           i18n.setLocaleCookie(i18n.locale.value);
//         }
//       },
//       { immediate: true },
//     );
//     // if (!cookie) {
//     //   i18n.setLocaleCookie(i18n.defaultLocale);
//     // }
//   },
// });
export default defineNuxtPlugin((nuxtApp) => {
  // On the server, @nuxtjs/i18n already resolves the locale from the URL prefix
  // (strategy: prefix_except_default). Running the cookie/locale sync below during
  // SSR races with that and can reset prefixed routes (e.g. /ar/...) back to the
  // default locale on a cold/direct load. Keep this client-only.
  if (import.meta.server) return;

  const i18n: any = nuxtApp.vueApp.$nuxt.$i18n;
  const route = useRoute();
  const localeCookie = useCookie("locale");

  const supportedLocales = [
    "en",
    "fr",
    "es",
    "de",
    "ar",
    "ru",
    "tr",
    "az",
    "zh",
    "it",
    "he",
    "fa",
    "pt",
    "uz",
  ];

  const getLocaleFromPath = (path: string) => {
    const match = path.match(/^\/([a-z]{2})(\/|$)/);
    return match?.[1] || null;
  };
  const path = route.path;

  watch(
    () => route.path,
    (path) => {
      const localeFromPath = getLocaleFromPath(path);
      // اگر URL زبان دارد
      if (localeFromPath && supportedLocales.includes(localeFromPath)) {
        if (i18n.locale.value !== localeFromPath) {
          i18n.setLocale(localeFromPath);
        }

        localeCookie.value = localeFromPath;
        return;
      } else if (!localeFromPath) {
        i18n.setLocale(i18n.defaultLocale);
        i18n.setLocaleCookie(i18n.defaultLocale);
      }

      // // اگر URL بدون زبان است → فقط fallback (نه override دائم)
      if (!localeCookie.value) {
        localeCookie.value = i18n.defaultLocale;
      }
    },
    { immediate: true },
  );

  // sync i18n → cookie
  watch(
    () => i18n.locale.value,
    (val) => {
      localeCookie.value = val;
    },
  );
});
